import { ToastProps } from '@/types/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ToastState = ToastProps;

interface ToastsState {
  toasts: ToastState[];
}

const initialState: ToastsState = {
  toasts: [],
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    addToast: (state, action: PayloadAction<Omit<ToastState, 'id'>>) => {
      state.toasts.push({
        ...action.payload,
        id: `${Date.now().toString()}-${Math.random().toString()}`,
      });
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter(
        (toast) => toast.id !== action.payload
      );
    },
  },
});

export const { addToast, removeToast } = toastSlice.actions;
export default toastSlice.reducer;
